export default "__VITE_ASSET__BKyZ3sPI__"